import { Map } from 'maplibre-gl';

export const SOURCE_ID = 'hm-coverageData';
export const TILES_URL =
  'https://network-tiles.s3.us-west-2.amazonaws.com/h3-all-90.pmtiles';

export async function addSource(map: Map) {
  if (map && !map.getSource(SOURCE_ID)) {
    try {
      map.addSource(SOURCE_ID, {
        type: 'vector',
        url: 'pmtiles://' + TILES_URL,
      });
    } catch (err) {
      console.log(err);
    }
  }
}
